import React, { useRef, useState } from 'react';
import { Box, CloudinaryImage, Text, RichText, Button, IconButton, IconCloseX24, IconPlay16, IconPause16 } from '@stitch-fix/mode-react';
import { useRouter } from 'next/router';
import { isAndroidApp } from '../../../../../utils/android/android';
import { Video } from '../../../../../types/definitions/vendor/graphql-schema.d';
import styles from './style.module.scss';
type OnboardingWelcomeProps = {
  video?: Video;
  onNext: () => void;
};
const IntroComponent = ({
  video,
  onNext
}: OnboardingWelcomeProps) => {
  const router = useRouter();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const handleTogglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };
  const isAndroid = isAndroidApp();
  return <Box className={styles.container} style={isAndroid ? {
    // Android: video determines height naturally, full width
    width: '100%',
    minHeight: '93vh',
    margin: 0
  } : {
    // Web: video determines height naturally, page scrolls
    width: 'calc(100% - 5rem)',
    maxWidth: '400px',
    margin: '0 auto 3rem',
    borderRadius: '8px'
  }}>
      {/* Video layer - defines container height */}
      {video ? <video ref={videoRef} autoPlay muted playsInline poster={video.posterImageUrl ?? undefined} className={styles.videoBackground} style={isAndroid ? {
      height: '100%'
    } : undefined} onEnded={onNext}>
          <source src={`${video.baseUrl}${video.mediaPath}`} type="video/mp4" />
          Your browser does not support the video tag.
        </video> : <Box className={styles.videoBackground}>
          <CloudinaryImage alt="Onboarding Welcome" baseUrl="https://res.cloudinary.com/stitch-fix/image/upload/" mediaPath="v1753825042/vision/assets/onboarding.gif" sizes={{
        sm: 400
      }} transforms={{
        f: 'auto',
        q: 'auto'
      }} />
        </Box>}

      {/* Gradient overlay layer */}
      <Box aria-hidden="true" className={styles.videoOverlay} />

      {/* Content layer */}
      <Box className={styles.contentLayer}>
        {isAndroid && <Box className={styles.headerContainer}>
            <Text setting="title-medium" color="white" align="center">
              <RichText>*Stitch Fix Vision*</RichText>
            </Text>
            <Box className={styles.closeButton}>
              <IconButton aria-label="Close" onClick={() => {
            router.push('/home');
          }}>
                <IconCloseX24 color="white" title="Close icon" />
              </IconButton>
            </Box>
          </Box>}

        <Box className={styles.textContainer} style={{
        marginTop: 'auto'
      }}>
          <Text family="regular" height="standard" scale="8">
            A fresh new way to
          </Text>
          <Text family="regular" height="standard" scale="8" style={{
          fontWeight: 700
        }}>
            see the look on you
          </Text>
          {video && <Box className={styles.playButtonContainer}>
              <button className={styles.playButton} aria-label={`${isPlaying ? 'Pause' : 'Play'} background video`} type="button" onClick={handleTogglePlay}>
                {isPlaying ? <IconPause16 title="pause background video" data-testid="pause-icon" /> : <IconPlay16 title="play background video" data-testid="play-icon" />}
              </button>
            </Box>}
          <Box maxWidth="400px" width="100%">
            <Button width="fill" onClick={onNext}>
              See the magic
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>;
};
const Intro = React.memo(IntroComponent);
export default Intro;